import { render, staticRenderFns } from "./FlowItem.vue?vue&type=template&id=355c1d75&scoped=true&"
import script from "./FlowItem.vue?vue&type=script&lang=js&"
export * from "./FlowItem.vue?vue&type=script&lang=js&"
import style0 from "./FlowItem.vue?vue&type=style&index=0&id=355c1d75&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355c1d75",
  null
  
)

export default component.exports